// core version + navigation, pagination modules:
import Swiper, { Navigation } from 'swiper';
// import Swiper and modules styles
import 'swiper/css';
import 'swiper/css/navigation';

const isIpadPro = () => {
    let ratio = window.devicePixelRatio || 1;
    let screen = {
        width : window.screen.width * ratio,
        height : window.screen.height * ratio
    };
    return (screen.width === 1488 && screen.height === 2266) ||(screen.width === 2048 && screen.height === 2732) || (screen.width === 2732 && screen.height === 2048) || (screen.width === 1536 && screen.height === 2048) || (screen.width === 2048 && screen.height === 1536) || (screen.width === 1668 && screen.height === 2388) || (screen.width === 2388 && screen.height === 1668) || (screen.width === 1620 && screen.height === 2160);
}
const servicesOverviewSlider = () => {
    if(document.querySelector('.kruse-services-slider')){
        const vw = Math.max(document.documentElement.clientWidth || 0, window.innerWidth || 0);
        const allSliders = document.querySelectorAll('.kruse-services-slider');
        allSliders.forEach(slider =>{
            let controls = slider.querySelector('.swiper-nav');
            let alwaysSlider = false;
            let referenceSlider = slider.classList.contains('kruse-reference-slider');
            let sequenceCards = slider.querySelectorAll('.kruse-card-sequence');
            if(sequenceCards.length > 3 || referenceSlider) alwaysSlider = true;
            if(sequenceCards.length > 0){
                let maxHeight = 0;
                sequenceCards.forEach(c => {
                    let title = c.querySelector('p.has-md-font-size');
                    if(title.offsetHeight > maxHeight){
                        maxHeight = title.offsetHeight;
                    }
                })
                sequenceCards.forEach(c => {
                    let title = c.querySelector('p.has-md-font-size');
                    title.style.minHeight = maxHeight - 33 + 'px';
                })
            }
            if(isIpadPro() && slider.querySelectorAll('.kruse-services--item').length > 2) alwaysSlider = true;
            if(vw > 1024 && !alwaysSlider) {
                controls.classList.add('d-none');
                slider.classList.remove('has-controls-enabled')
                // destroy slider if viewport switch from mobile to desktop style (e.g. tablet rotated)
                if (slider.querySelector('.swiper-wrapper')) {
                    let wrapper = slider.querySelector('.swiper-wrapper');
                    let allSlides = slider.querySelectorAll('.swiper-slide');

                    const swiper = new Swiper(slider, {}).destroy()


                    if (allSlides.length > 0) {
                        allSlides.forEach(s => {
                            wrapper.removeChild(s);
                            slider.insertBefore(s, controls);
                            s.classList.remove('swiper-slide');
                        })
                    }
                    slider.removeChild(wrapper);
                    if(!slider.classList.contains('kruse-advisor-teaser-holder')){
                        slider.classList.add('row');
                    }

                }
            }
            if(vw < 1025 || alwaysSlider){
                //create slider if viewport is mobile
                if(!slider.classList.contains('kruse-advisor-teaser-holder')){
                    slider.classList.remove('row');
                }

                if(!slider.querySelector('.swiper-wrapper')){
                    let createWrapper = document.createElement('div');
                    createWrapper.classList.add('swiper-wrapper');
                    slider.insertBefore(createWrapper, controls);
                }
                let wrapper = slider.querySelector('.swiper-wrapper')
                let cards = slider.querySelectorAll('.kruse-services--item');
                if (wrapper.querySelector('.swiper-slide') == null) {
                    if (cards.length > 0) {
                        let cardsLength = cards.length;
                        cards.forEach(card => {
                            slider.removeChild(card);
                            wrapper.appendChild(card);
                            card.classList.add('swiper-slide');
                            if(alwaysSlider){
                                card.style.zIndex = cardsLength;
                                cardsLength = cardsLength - 1;
                            }


                        });
                    }
                }
                if(referenceSlider){
                    const swiper = new Swiper(slider, {
                        modules: [Navigation],
                        slidesPerView: 1.15,
                        spaceBetween: 24,
                        preloadImages: false,
                        navigation: {
                            nextEl: controls.querySelector('.swiper-button-next'),
                            prevEl: controls.querySelector('.swiper-button-prev'),
                        },
                        breakpoints: {
                            711: {
                                slidesPerView: 'auto',
                            },
                            1025: {
                                slidesPerView: 'auto',
                                spaceBetween: 50,
                            },
                            1200: {
                                slidesPerView: 'auto',
                                spaceBetween: 100,
                            },
                            1600: {
                                slidesPerView: 'auto',
                                spaceBetween: 200,
                            },
                            2500: {
                                slidesPerView: 4,
                                spaceBetween: 200,
                            },

                        }
                    })
                }else{
                    const swiper = new Swiper(slider, {
                        modules: [Navigation],
                        slidesPerView: 1.15,
                        spaceBetween: 24,
                        preloadImages: false,
                        navigation: {
                            nextEl: controls.querySelector('.swiper-button-next'),
                            prevEl: controls.querySelector('.swiper-button-prev'),
                        },
                        breakpoints: {
                            711: {
                                slidesPerView: 1.5,
                            },
                            1025: {
                                slidesPerView: 2.15,
                            },
                            1200: {
                                slidesPerView: 3,
                            },
                            2500: {
                                slidesPerView: 4,
                                navigation:{
                                    enabled: false,
                                }
                            },

                        }
                    })
                }


                controls.classList.remove('d-none');
                slider.classList.add('has-controls-enabled')


            }
        })

    }
}
export default servicesOverviewSlider;